export const RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY = 'file-download-will-begin-shortly';
export const RCE_FILE_TOO_BIG = 'file-too-big';
export const RCE_FILE_UPLOAD_LIMITED = 'file-upload-limited';
export const RCE_FILE_UPLOAD_FAILURE = 'file-upload-failure';
export const RCE_COLOR_LIMIT_REACHED = 'rce-color-limit-reached';
//# sourceMappingURL=messages.js.map